import React, { useEffect } from 'react';
import SideMenu from '../common/SideMenu';

interface TextPageProps {
  children: string;
  nav?: { title: string; items: { href: string; name: string }[] };
  className?: string;
}

const TextPage: React.FC<TextPageProps> = ({ children, nav, className }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={`content ${className || ''}`}>
      <div className="page-with-sidebar setup-config text-page">
        <div className="page-content" dangerouslySetInnerHTML={{ __html: children }} />
        <div className="side-menu js_tabs">{nav && <SideMenu {...nav} />}</div>
      </div>
    </div>
  );
};

export default TextPage;
